import React from 'react';
import Tippy from '@tippyjs/react';

import { map } from "lodash";

import { COLORS } from "../../../../helpers/constants";
import { acronymChanger, acronymInterpreter } from '../../../../helpers/functions';

const colors = (index) => {
  const allColors = {
    'R': COLORS.red,
    'AM': COLORS.yellow,
    'V': COLORS.green,
    'AZ': COLORS.blue,
    'DES': COLORS.petrol,
    'LID': COLORS.purple,
    'INV': COLORS.lightgreen,
    'EST': COLORS.orange,
    'REC': COLORS.peachyellow,
    'AY': COLORS.burgundy,
    'PAZ': COLORS.lightblue,
  };
  return allColors[index] || COLORS.yellow;
};

const BarCharts = ({ data }) => {
  const getTitle = (e, index) => {
    if (e) {
      if (e.sectionTitle === 'Su Estilo de Trabajo') {
        return 'Su estilo Adaptado';
      }
      return e.sectionTitle;
    }
    return `T${index + 1}`;
  };
  return (
    <div className="gm-all-charts-container">
      {data?.results &&
        <>
          <div className="gm-ct-container">
            <table>
              <tbody>
                {map(data?.results || [], (e, index) => {
                  if (e?.sectionScore?.length > 1 && e?.sectionScore?.length <= 4) {
                    return (
                      <React.Fragment key={`table-5-${index}`}>
                        <tr className="gm-ct-section" >
                          <td className="gm-ct-title">{getTitle(e, index)}</td>
                          {map(e?.sectionScore || [], (section, index) => (
                            <td className="gm-ct-bar-container" key={`table-5-section-${index}`}>
                              <Tippy
                                content={acronymInterpreter(section?.indicatorAcronym)}
                                placement='bottom'
                              >
                                <div>
                                  <div className="gm-ct-bar" style={{ backgroundColor: colors(section?.indicatorAcronym), height: `${section?.DISC * 10 || 0}%` }} />
                                </div>
                              </Tippy>
                            </td>
                          ))}
                        </tr>
                        <tr className={`gm-ct-footer ${index === 0 ? 'gm-chart-limit-line' : ''}`}>
                          <td></td>
                          {map(e?.sectionScore, (data, index) =>
                          (<td key={`disc-section-${index}`}>
                            <div>
                              {acronymChanger(data?.indicatorAcronym) || 'NN'}
                            </div>
                            <div>
                              {data?.DISC.toFixed(1)}
                            </div>
                          </td >)
                          )}
                          <td></td>
                        </tr>
                      </React.Fragment>
                    );
                  }
                })}
              </tbody>
            </table>
          </div>
          <div className="gm-ct-container">
            <table>
              <tbody>
                {map(data?.results || [], (e, index) => {
                  if (e?.sectionScore?.length > 4 && e?.sectionScore?.length <= 7) {
                    return (
                      <tr className="gm-ct-section" key={`table-7-${index}`}>
                        <td className="gm-ct-title">{e?.sectionTitle || `T${index + 1}`}</td>
                        {map(e?.sectionScore || [], (section, index) => (
                          <td className="gm-ct-bar-container" key={`table-7-section-${index}`}>
                            <Tippy
                              content={acronymInterpreter(section?.indicatorAcronym)}
                              placement='bottom'
                            >
                              <div>
                                <div className="gm-ct-bar" style={{ backgroundColor: colors(section?.indicatorAcronym), height: `${section?.DISC * 10 || 0}%` }} />
                              </div>
                            </Tippy>
                          </td>
                        ))}
                      </tr>
                    );
                  }
                })}
                <tr className="gm-ct-footer">
                  <td></td>
                  {map(data?.results[2]?.sectionScore, (data, index) => (
                    <td key={`disc-section-${index}`}>
                      <div>
                        {acronymChanger(data?.indicatorAcronym) || 'NN'}
                      </div>
                      <div>
                        {data?.DISC.toFixed(1)}
                      </div>
                    </td >
                  ))}
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </>}
      {!data?.results &&
        <div className="gm-ct-no-data">No hay resultados que mostrar</div>
      }
    </div>
  );
}

export default BarCharts;